export default __webpack_public_path__ + "static/media/_DSC0271.979929db.JPG";